<template>
  <div
    class="preview-product-modal"
    @click.self="$emit('close')"
  >
    <div
      class="modal-content"
      :style="contentStyle"
    >
      <!-- 閉じるボタン -->
      <button
        class="close-button"
        @click="$emit('close')"
      >
        <v-icon
          small
          :color="theme.textColor"
        >
          mdi-close
        </v-icon>
      </button>

      <!-- 商品画像 -->
      <div
        class="product-image"
        :style="imageStyle"
      >
        <img
          v-if="product.imageUrl"
          :src="product.imageUrl"
          :alt="product.name"
        >
        <v-icon
          v-else
          :color="theme.primaryColor"
          size="48"
        >
          mdi-glass-cocktail
        </v-icon>
      </div>

      <!-- 商品情報 -->
      <div class="product-info">
        <h3
          class="product-name"
          :style="nameStyle"
        >
          {{ product.name }}
        </h3>
        <div
          class="product-price"
          :style="priceStyle"
        >
          {{ formatPrice(product.price) }}
        </div>
      </div>

      <!-- 数量選択 -->
      <div class="quantity-section">
        <div class="quantity-controls">
          <button
            class="quantity-btn"
            :style="quantityBtnStyle"
          >
            <v-icon small>
              mdi-minus
            </v-icon>
          </button>
          <span
            class="quantity-value"
            :style="nameStyle"
          >1</span>
          <button
            class="quantity-btn"
            :style="quantityBtnStyle"
          >
            <v-icon small>
              mdi-plus
            </v-icon>
          </button>
        </div>
      </div>

      <!-- 注文ボタン -->
      <button
        class="order-button"
        :style="orderBtnStyle"
      >
        カートに追加
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'PreviewProductModal',

  props: {
    product: {
      type: Object,
      required: true,
    },
    theme: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const contentStyle = computed(() => ({
      backgroundColor: props.theme.cardColor,
    }))

    const imageStyle = computed(() => ({
      backgroundColor: `${props.theme.primaryColor}20`,
    }))

    const nameStyle = computed(() => ({
      color: props.theme.textColor,
    }))

    const priceStyle = computed(() => ({
      color: props.theme.primaryColor,
    }))

    const quantityBtnStyle = computed(() => ({
      backgroundColor: props.theme.backgroundColor,
      color: props.theme.textColor,
    }))

    const orderBtnStyle = computed(() => ({
      backgroundColor: props.theme.primaryColor,
      color: props.theme.backgroundColor,
    }))

    const formatPrice = price => {
      return `${price.toLocaleString()}`
    }

    return {
      contentStyle,
      imageStyle,
      nameStyle,
      priceStyle,
      quantityBtnStyle,
      orderBtnStyle,
      formatPrice,
    }
  },
}
</script>

<style scoped>
.preview-product-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-end;
  z-index: 10;
}

.modal-content {
  width: 100%;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.product-image {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.product-info {
  margin-bottom: 16px;
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px;
}

.product-price {
  font-size: 18px;
  font-weight: 700;
}

.product-price::before {
  content: '\u00A5';
}

.quantity-section {
  margin-bottom: 16px;
}

.quantity-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.quantity-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-value {
  font-size: 18px;
  font-weight: 600;
  min-width: 32px;
  text-align: center;
}

.order-button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.order-button:hover {
  opacity: 0.9;
}
</style>
